import { Employee } from '../bonus/types';
import { createIdbCache, QBA_CACHE_CONFIG  } from '../../lib/idb';

const STORE = 'override_employee_cache';

export const OVERRIDE_EMPLOYEE_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

export interface OverrideEmployeeCacheKey {
  jobFamily: string;
}

function buildKey(p: OverrideEmployeeCacheKey): string {
  return `override|${p.jobFamily}`;
}

const cache = createIdbCache<Employee[]>({ ...QBA_CACHE_CONFIG, storeName: STORE });

export const overrideEmployeeIdb = {
  get(params: OverrideEmployeeCacheKey): Promise<Employee[] | null> {
    return cache.get(buildKey(params));
  },

  set(params: OverrideEmployeeCacheKey, employees: Employee[]): Promise<void> {
    return cache.set(buildKey(params), employees, OVERRIDE_EMPLOYEE_TTL_MS);
  },

  invalidate(params: OverrideEmployeeCacheKey): Promise<void> {
    return cache.delete(buildKey(params));
  },

  clearAll(): Promise<void> {
    return cache.clearAll();
  },
};